<h3>Cargador</h3>
<div class="dashboard-counters">
  <ion-card>
    <ion-card-content>
      <div class="counter">{{ todayDocumentsAsShipperCount() }}</div>
      <div class="label">Hoy</div>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-content>
      <div class="counter">{{ nextDocumentsAsShipperCount() }}</div>
      <div class="label">Próximos días</div>
    </ion-card-content>
  </ion-card>
  <ion-card>
    <ion-card-content>
      <div class="counter">{{ pastDocumentsAsShipperCount() }}</div>
      <div class="label">Archivados</div>
    </ion-card-content>
  </ion-card>
</div>
